module.exports = __webpack_public_path__ + "img/title19_2.ceab0361.png";